module.exports = "/assets/gift-events-listing/BW24-banner-mobile.png?a+PNn2T";